import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    ReportTab,
    REPORT_TABS,
    convertDateToDDDMMMDDYYYY,
} from '../../common';
import { Tabs, Tooltip } from '../../base';
import {
    RecruitmentFunnel,
    TimeToHire,
    SourceOfHire,
} from '../../components/ReportsComponents';
import {
    StyledReportsPageWrapper,
    StyledTitleRow,
    StyledTitle,
    StyledDate,
    StyledReportsContent,
    StyledTab,
    StyledMainArea,
} from './ReportsPage.styles';

const REPORT_TAB_CONTENT: Partial<Record<ReportTab, ReactNode>> = {
    [ReportTab.TIME_TO_HIRE]: <TimeToHire />,
    [ReportTab.RECRUITMENT_FUNNEL]: <RecruitmentFunnel />,
    [ReportTab.SOURCE_OF_HIRE]: <SourceOfHire />,
};

const ReportsPage = () => {
    const { t, i18n } = useTranslation();
    const [activeTab, setActiveTab] = useState<ReportTab>(
        ReportTab.TIME_TO_HIRE
    );

    const formatDate = () => {
        return convertDateToDDDMMMDDYYYY(
            new Date().toISOString(),
            i18n.language
        );
    };

    const handleTabChange = (_: React.SyntheticEvent, newValue: ReportTab) => {
        setActiveTab(newValue);
    };

    return (
        <StyledReportsPageWrapper>
            <StyledTitleRow container>
                <StyledTitle variant="h4">{t('reportsPage.title')}</StyledTitle>
                <StyledDate variant="body2">{formatDate()}</StyledDate>
            </StyledTitleRow>

            <StyledReportsContent>
                <Tabs
                    orientation="vertical"
                    value={activeTab}
                    onChange={handleTabChange}
                >
                    {REPORT_TABS.map((tab, index) => {
                        const isLast = index === REPORT_TABS.length - 1;

                        return REPORT_TAB_CONTENT[tab.key] ? (
                            <StyledTab
                                key={tab.key}
                                value={tab.key}
                                label={t(tab.labelKey)}
                                isLast={isLast}
                            />
                        ) : (
                            <Tooltip
                                key={tab.key}
                                title={t('reportsPage.comingSoon')}
                                placement="top"
                            >
                                <StyledTab
                                    value={tab.key}
                                    label={t(tab.labelKey)}
                                    disabled
                                    isLast={isLast}
                                />
                            </Tooltip>
                        );
                    })}
                </Tabs>

                <StyledMainArea>{REPORT_TAB_CONTENT[activeTab]}</StyledMainArea>
            </StyledReportsContent>
        </StyledReportsPageWrapper>
    );
};

export default ReportsPage;
